/**
 * "Trocar de câmera" (frontal e traseira) no celular, onde a seta do menu de dispositivos fica
 * escondida. Passa para a próxima câmera da lista; com uma só câmera, o botão não aparece.
 */
import { useMediaDeviceSelect } from '@livekit/components-react';
import { SwitchCamera } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ROUND_BUTTON, SIZE } from './controlStyles';
import { activeDeviceOf } from './DeviceMenu';

/** Id da câmera seguinte, voltando à primeira depois da última. */
export function nextDeviceId(devices, activeDeviceId) {
    if (devices.length < 2) return null;
    const current = devices.findIndex((d) => d.deviceId === activeDeviceOf(devices, activeDeviceId));
    return devices[(current + 1) % devices.length].deviceId;
}

/** @param {{ variant: keyof typeof SIZE }} props */
export function FlipCameraButton({ variant }) {
    const { devices, activeDeviceId, setActiveMediaDevice } = useMediaDeviceSelect({ kind: 'videoinput' });
    const next = nextDeviceId(devices, activeDeviceId);
    if (!next) return null;
    return (
        <button
            type="button"
            aria-label="Trocar de câmera"
            onClick={() => setActiveMediaDevice(next)}
            className={cn(ROUND_BUTTON, SIZE[variant].btn, 'sm:hidden')}
        >
            <SwitchCamera className={SIZE[variant].icon} aria-hidden="true" />
        </button>
    );
}
